import { useQuery } from 'react-query';
import getSummary from 'data/requests/getSummary';
import { Summary } from 'model/summary';

const useSummary = (brandId: string) => {
  const { data, isLoading, refetch } = useQuery<Summary>(
    ['summary', brandId],
    () => getSummary(brandId),
    {
      enabled: false,
    },
  );

  return { summary: data, isLoading, refetch };
};

export default useSummary;
